import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { heroData } from '../data/mock';
import VideoBackgroundHero from './VideoBackgroundHero';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector('#contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex md:items-center items-start justify-center overflow-hidden pt-20 md:pt-0"
    >
      {/* Video Background */}
      <VideoBackgroundHero />

      {/* Animated Background Elements */}
      <div className="absolute inset-0 z-10 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 max-[1366px]:w-56 max-[1366px]:h-56 bg-gradient-to-br from-transparent via-cyan-400/10 to-blue-500/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 max-[1366px]:w-72 max-[1366px]:h-72 bg-blue-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      {/* Mascot Image - Fixed Position with Shadow */}
      <div className="absolute left-1/2 bottom-32 transform -translate-x-1/2 md:left-auto md:bottom-auto md:right-16 md:top-1/2 max-[1366px]:top-[55%] md:translate-x-0 md:-translate-y-1/2 z-20 block opacity-30 md:opacity-90">
        <div className="relative">
          {/* Shadow below mascot - closer to paws */}
          <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 w-48 h-5 bg-black/40 rounded-full blur-lg"></div>

          {/* Mascot */}
          <div className="absolute inset-0 -z-10">
            <div className="absolute -inset-12 bg-gradient-to-br from-cyan-400/15 via-blue-500/10 to-transparent rounded-full blur-[80px]"></div>
          </div>
          <img
            src="https://customer-assets.emergentagent.com/job_bezalel-ux-update/artifacts/k54w94pu_bezalel.png"
            alt="Bezalel - Tejón Tecnológico"
            className="w-40 sm:w-56 md:w-[546px] h-auto md:drop-shadow-2xl opacity-90 relative z-10"
            style={{ filter: 'brightness(1.1) drop-shadow(0 0 40px rgba(6, 182, 212, 0.3))' }}
          />
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 z-20 relative lg:grid lg:grid-cols-2 lg:items-center lg:gap-8">
        <div
          className={`max-w-4xl mx-auto lg:mx-0 lg:max-w-2xl text-center lg:text-left transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
            }`}
        >
          {/* Badge */}{/*
          <div className="hidden md:inline-flex max-[1366px]:hidden items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20 mb-8">
            <Sparkles className="w-4 h-4 text-cyan-400" />
            <span className="text-sm text-white font-medium">
              Soluciones Tecnológicas de Vanguardia
            </span>
          </div>  */}

          {/* Main Title */}
          <h1 className="text-5xl md:text-7xl max-[1366px]:text-6xl font-bold text-white mb-4 leading-tight text-center lg:text-left">
            Innovación Tecnológica para tu Éxito Digital
          </h1>



          {/* Description */}
          <p className="text-base md:text-xl text-cyan-100 mb-10 max-w-3xl mx-auto leading-relaxed px-6 text-center lg:text-left">
            Infraestructura, Desarrollo y Seguridad potenciados con IA. Todo lo que tu empresa necesita en un solo lugar.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white px-8 py-4 min-h-[44px] text-lg font-semibold shadow-2xl hover:shadow-cyan-500/50 transition-all duration-300 group rounded-full w-11/12 sm:w-auto mt-4"
            >
              ¡Contáctanos Hoy! →
            </Button>
            <Button
              onClick={(e) => {
                e.preventDefault();
                const element = document.querySelector('#services');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }}
              size="lg"
              variant="outline"
              className="hidden sm:inline-flex bg-transparent border border-white/50 text-white hover:bg-white/10 px-8 py-6 text-lg font-semibold"
            >Ver Servicios</Button>
          </div>

          {/* Stats */}
          <div className="mt-16 pt-16 max-[1366px]:mt-10 max-[1366px]:pt-10 border-t border-white/20 flex items-center gap-6 lg:justify-start justify-center">
            <div className="text-left">
              <div className="text-4xl font-bold text-cyan-400 mb-1">7+</div>
              <div className="text-sm text-white/80">Años de Experiencia</div>
            </div>
            <div className="h-10 w-px bg-white/20"></div>
            <div className="text-left">
              <div className="text-4xl font-bold text-cyan-400 mb-1">50+</div>
              <div className="text-sm text-white/80">Proyectos Entregados</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce max-[1366px]:hidden">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
